export const themeH = {
  name: "象牙沙龍",
  colors: {
    bg: "#FAF6F1",
    bgSecondary: "#F2EBE2",
    text: "#1A1614",
    textSecondary: "#5C5248",
    textMuted: "#7A6F62",
    accent: "#8B6E4E",
    accentText: "#FFFFFF",
    accentAlt: "#7A5F42",
    accentWarm: "#B8956A",
    accentOrange: "#A47C54",
    available: "#6A8C5A",
    availableText: "#1A1614",
    claimed: "#D4C8B8",
    cardBg: "#FFFFFF",
    cardBorder: "#E8E0D4",
    overlay: "rgba(250,246,241,0.8)",
    heroBg: "#1A1614",
    heroText: "#FAF6F1",
  },
  fonts: {
    heading: "var(--font-cormorant), 'Noto Serif TC', serif",
    body: "var(--font-noto-sans), sans-serif",
    accent: "var(--font-cormorant), serif",
  },
  radius: { sm: "6px", md: "10px", lg: "16px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "56px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 12px rgba(139,110,78,0.06)",
    cardHoverShadow: "0 4px 20px rgba(139,110,78,0.10)",
    bgTexture: true,
    textureOpacity: 0.03,
  },
};
